const default_timeout = 15000

function get_base_url() {
  if (process.env.NODE_ENV === 'development') {
    return '/api'
  }
  const env_base_url = process.env.VUE_APP_API_BASE_URL
  if (env_base_url) {
    return env_base_url
  }
  return '/api'
}

function build_url(path) {
  const base_url = get_base_url()
  if (!path) return base_url
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }
  if (path.startsWith('/')) {
    return `${base_url}${path}`
  }
  return `${base_url}/${path}`
}

export async function handleResponse(response) {
  let body = null

  try {
    body = await response.json()
  } catch (e) {
    const error = new Error('响应解析失败')
    error.code = 'PARSE_ERROR'
    error.status = response.status
    throw error
  }

  const code = body && typeof body.code !== 'undefined' ? body.code : null
  const message = body && body.message ? body.message : '请求失败'

  if (code === 4001) {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('user_profile')
      }
    } catch (e) {
      // ignore storage error
    }
    if (typeof window !== 'undefined') {
      if (window.location && window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    const error = new Error(message)
    error.code = code
    error.status = response.status
    error.data = body
    throw error
  }

  if (!response.ok) {
    const error = new Error(message)
    error.code = code || response.status
    error.status = response.status
    error.data = body
    throw error
  }

  if (code && code !== 2001) {
    const error = new Error(message)
    error.code = code
    error.status = response.status
    error.data = body
    throw error
  }

  return body
}

export async function httpRequest(method, path, options = {}) {
  const url = build_url(path)
  const headers = options.headers || {}
  const query = options.query || null
  const body_data = options.body || null
  const timeout = typeof options.timeout === 'number' ? options.timeout : default_timeout
  const provided_signal = options.signal || null

  let final_url = url

  if (query && typeof query === 'object') {
    const search_params = new URLSearchParams()
    Object.keys(query).forEach((key) => {
      const value = query[key]
      if (value === undefined || value === null) return
      search_params.append(key, String(value))
    })
    const query_string = search_params.toString()
    if (query_string) {
      final_url = `${url}${url.includes('?') ? '&' : '?'}${query_string}`
    }
  }

  const final_headers = { ...headers }

  try {
    if (!Object.prototype.hasOwnProperty.call(final_headers, 'Authorization')) {
      if (typeof window !== 'undefined' && window.localStorage) {
        const stored_token = window.localStorage.getItem('token')
        if (stored_token) {
          final_headers.Authorization = `Bearer ${stored_token}`
        }
      }
    }
  } catch (e) {
    // ignore storage error
  }

  if (!Object.prototype.hasOwnProperty.call(final_headers, 'Accept')) {
    final_headers.Accept = 'application/json'
  }

  const controller = provided_signal ? null : new AbortController()
  const request_signal = provided_signal || (controller ? controller.signal : undefined)
  const has_timeout = controller && typeof timeout === 'number' && timeout > 0
  const timer = has_timeout
    ? setTimeout(() => {
        controller.abort()
      }, timeout)
    : null

  const fetch_options = {
    method: method.toUpperCase(),
    headers: { ...final_headers },
    signal: request_signal,
    credentials: 'include'
  }

  if (body_data !== null && body_data !== undefined && !(body_data instanceof FormData)) {
    fetch_options.headers['Content-Type'] = 'application/json'
    fetch_options.body = JSON.stringify(body_data)
  } else if (body_data instanceof FormData) {
    fetch_options.body = body_data
  }

  try {
    const response = await fetch(final_url, fetch_options)
    if (timer) {
      clearTimeout(timer)
    }
    if (options.stream) {
      return response
    }
    return await handleResponse(response)
  } catch (err) {
    if (timer) {
      clearTimeout(timer)
    }
    if (err.name === 'AbortError') {
      const error = new Error('请求超时')
      error.code = 'TIMEOUT'
      throw error
    }
    if (!err.code) {
      const error = new Error('网络异常')
      error.code = 'NETWORK_ERROR'
      throw error
    }
    throw err
  }
}

export function get(path, params = {}, options = {}) {
  const merged_options = { ...options, query: params }
  return httpRequest('GET', path, merged_options)
}

export function post(path, data = {}, options = {}) {
  const merged_options = { ...options, body: data }
  return httpRequest('POST', path, merged_options)
}

export function put(path, data = {}, options = {}) {
  const merged_options = { ...options, body: data }
  return httpRequest('PUT', path, merged_options)
}

export function del(path, params = {}, options = {}) {
  const merged_options = { ...options, query: params }
  return httpRequest('DELETE', path, merged_options)
}

export function upload(path, form_data, options = {}) {
  const merged_options = { ...options, body: form_data }
  return httpRequest('POST', path, merged_options)
}

export function parsePagination(data, current_page, list_field = 'list') {
  const safe_data = data || {}
  const meta = safe_data.data && safe_data.data.meta ? safe_data.data.meta : {}
  const pagination = meta.pagination || {}
  const server_page = typeof pagination.current_page === 'number' ? pagination.current_page : current_page || 1
  const total_pages = typeof pagination.total_pages === 'number' ? pagination.total_pages : server_page
  const has_more = server_page < total_pages
  const list_source = safe_data.data && safe_data.data[list_field] ? safe_data.data[list_field] : []

  return {
    list: Array.isArray(list_source) ? list_source : [],
    page: server_page,
    has_more,
    raw: safe_data
  }
}

export default {
  get,
  post,
  put,
  del,
  upload,
  parsePagination
}
